<template>
<div class="main">
  <div v-if="loading" class="fill-height d-flex justify-content-center align-items-center">
    <loading-indicator />
  </div>
  <div v-else class="d-flex" style="height: 100%">
    <div class="task-overview" style="flex: 2">
      <div class="d-flex justify-content-center" style="max-width: 680px;">
        <div style="display: inline-block;">
          <span class="text--xl text--bold">
            {{task.description || task.title || 'Step'}}
          </span>
          <div class="spacer--xl" />
          <div v-if="taskTemplate.tutorialVideo">
            <video-player :options="taskTemplate.tutorialVideo" />
            <div class="spacer--xl" />
          </div>
          <div
            v-for="(instruction, i) of taskTemplate.instructions"
            :key="i"
          >
            <div class="instruction-panel">
              <div class="mb-3">
                <span class="text--m text--bold">{{instruction.title}}</span>
              </div>
              <div v-if="instruction.title === 'How do I do it?'" class="list instruction-content" v-html="instruction.content" />
              <p v-else class="text--m instruction-content">{{instruction.content}}</p>
            </div>
            <div class="spacer--xl" />
          </div>

          <div v-if="taskTemplate.resources && taskTemplate.resources.length" class="resources">
            <div
              v-for="(resource, i) in taskTemplate.resources"
              :key="i"
            >
              <div v-if="resource.type === 'link'">
                <a-btn
                  outlined
                  :append-icon="require('@/assets/icons/link-mdi.svg')"
                  @click="openLink(resource.url)"
                >{{resource.title}}</a-btn>
              </div>
              <div v-else-if="resource.type === 'file'">
                <a-btn
                  outlined
                  :append-icon="require('@/assets/icons/download.svg')"
                  @click="downloadFromS3(resource.key)"
                >{{resource.title}}</a-btn>
              </div>
              <div v-else-if="resource.type === 'email'">
                <a-btn
                  outlined
                  :append-icon="require('@/assets/icons/email-mdi.svg')"
                  @click="composeEmail(resource)"
                >{{resource.title}}</a-btn>
              </div>
              <div v-else-if="resource.type === 'supplierList'" class="supplier-list">
                <div class="mb-2">
                  <span class="text--bold text--m">Suppliers</span>
                </div>


                <div
                  v-for="(supplier, index) of project_suppliers"
                  :key="`supplier-final-${index}`"
                  class="mb-4"
                >
                  <data-select
                    type="suppliers"
                    :changeHandler="updateSuppliers"
                    :value="supplier"
                    :filterIds="supplier_final_keys"
                    arg="Final"
                  />

                  <div class="d-flex pl-2">
                    <text-field
                      v-model="supplier.contactName"
                      @blur="saveProject"
                      label="Contact Name"
                      type="text"
                      class="mr-3"
                    />
                    <text-field
                      v-model="supplier.contactEmail"
                      @blur="saveProject"
                      label="Contact Email"
                      type="text"
                    />
                  </div>
                </div>

<!--                <div v-if="project_suppliers && project_suppliers.length <= 2">-->
<!--                  <span v-if="project_suppliers.length == 1">Add at least one more supplier</span>-->
<!--                  <span v-else>Add at least two suppliers</span>-->
<!--                </div>-->

                <data-select
                  type="suppliers"
                  label="Supplier"
                  :changeHandler="updateSuppliers"
                  :filterIds="supplier_final_keys"
                  arg="Final"
                  allowAdd
                />


<!--                <a-btn-->
<!--                  outlined-->
<!--                  :append-icon="require('@/assets/icons/add_mdi.svg')"-->
<!--                  @click="project.suppliers.push(-->
<!--                      {-->
<!--                        name: null,-->
<!--                        contactName: null,-->
<!--                        contactEmail: null,-->
<!--                        ratings: {-->
<!--                          price: 0,-->
<!--                          service: 0,-->
<!--                          quality: 0-->
<!--                        },-->
<!--                        cost: null,-->
<!--                        quotes: []-->
<!--                      })"-->
<!--                >{{resource.title}}</a-btn>-->
              </div>
              <div v-else-if="resource.type === 'scoreProposals'">
                <div v-for="(supplier, i) in project.projectSuppliers" :key="i" style="padding-bottom: 8px;">
                  <div style="border: solid 1px black; display: inline-block; padding: 16px; border-radius: 12px; min-width: 60%;">
                    <span class="text--l text--bold">{{supplier.name}}</span>
                    <div class="spacer--m" />
                    <text-field v-model="supplier.cost" label="Cost" type="number" :symbol="currencySymbol" @blur="$nextTick(() => saveProject())"/>
                    <div class="spacer--m" />
                    <UploadManager
                      label="Upload Quote"
                      :files="supplier.linkedFiles || []"
                      @fileAdded="Array.isArray(supplier.linkedFiles) ? supplier.linkedFiles.push($event) : supplier.linkedFiles = [$event]; $nextTick(() => saveProject());"
                      @removeFile="supplier.linkedFiles = supplier.linkedFiles.filter(file => file.id !== $event); $nextTick(() => saveProject());"
                    />
                    <div class="spacer--m" />
                    <div v-for="(key, i) in resource.proposalRatings" :key="i">
                      <Rating
                        :value="supplier.ratings ? supplier.ratings[key.toLowerCase().replace(' ','_')] : 0"
                        @input="setSupplierRating(supplier, key.toLowerCase().replace(' ','_'), $event); $nextTick(() => saveProject());"
                        :label="key.charAt(0).toUpperCase() + key.slice(1)"
                        @click="saveProject"
                      />
                    </div>
                    <div class="spacer--m" />
                    <span>Overall Score:</span>
                    <div class="spacer--xs" />
                    <span class="text--l text--bold">
                      {{
                        (Object.values(supplier.ratings || {}).reduce((sum, el) => sum + el, 0)
                          / (resource.proposalRatings.length || 1)).toFixed(1)
                      }}
                    </span>
                  </div>
                </div>
              </div>
              <div v-else-if="resource.type === 'supplierRecommendation'">

                <div class="mb-2">
                  <span class="text--bold text--m">Choose Selected Suppliers</span>
                </div>

                <div class="supplier-list">
                  <div
                    v-for="(supplier, index) of project_suppliers_awarded"
                    :key="`supplier-awarded-${index}`"
                  >
                    <data-select
                      type="suppliers"
                      :changeHandler="updateSuppliers"
                      :value="supplier"
                      :filterIds="supplier_awarded_keys"
                      arg="Selected"
                    />

                    <div class="instruction-panel textarea">
                      <material-input
                        v-model="supplier.comment"
                        type="textarea"
                        :label="`I chose ${supplier.name} because`"
                        :required="false"
                        name="EnterComment"
                        @blur="saveProject"
                      />
                    </div>
                    <div class="spacer--m" />
                  </div>
                  <data-select
                    type="suppliers"
                    :changeHandler="updateSuppliers"
                    :filterIds="supplier_awarded_keys"
                    arg="Selected"
                  />
                </div>
                <div class="spacer--m" />
                <text-field
                  v-model="project.estAnnualSpend"
                  @blur="saveProject"
                  label="Total Price Agreed"
                  type="number"
                  :symbol="currencySymbol" />
              </div>
              <div v-else-if="resource.type === 'docuSign'">
                <SelfServeDocuSign :config="resource" />
              </div>
            </div>
          </div>

          <div v-if="taskTemplate.uploads && taskTemplate.uploads.length">
            <div
              v-for="(upload, i) in taskTemplate.uploads"
              :key="i"
            >
              <UploadManager
                :label="upload.title"
                :files="task.linkedFiles"
                @fileAdded="task.linkedFiles.push($event); saveTask();"
                @removeFile="task.linkedFiles.splice(task.linkedFiles.findIndex(el => el.id === $event), 1); saveTask();"
              />
            </div>
            <div class="spacer--xl" />
          </div>

          <a-btn
            v-if="projectCompleted"
          >{{ `You're all done!` }}</a-btn>
          <a-btn
            v-else-if="task.completed"
            @click="$emit('nextTask')"
            :append-icon="require('@/assets/icons/right_arrow.svg')"
          >{{ `Go to the next task` }}</a-btn>
          <a-btn
            v-else
            @click="(canComplete && taskValid) ? $emit('complete') : null"
            :disabled="!(canComplete && taskValid)"
            :append-icon="require('@/assets/icons/right_arrow.svg')"
          >{{ `Mark as done and ${projectTaskCount > taskIndex +1 ? 'move to the next step' : 'finish!'}` }}</a-btn>
        </div>
      </div>
    </div>
    <div class="info-panel" style="flex: 1">
      <div class="spacer--xl" />
      <div>
        <div
          v-for="(note, i) in taskTemplate.notes"
          :key="i"
        >
          <Note
            :type="note.type"
            :content="note.content"
          />
          <div class="spacer--xl" />
        </div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
import ABtn from "@/components/SelfService/a-btn";
import Note from "@/components/SelfService/Note";
import UploadManager from "@/components/SelfService/UploadManager";
import TextField from "@/components/SelfService/text-field";
import Rating from "@/components/SelfService/Rating";
import DataSelect from "@/components/DataSelect";
import Vue from "vue";
import API from '@/api'
import materialInput from "@/components/MaterialInput";
import VideoPlayer from "@/components/VideoPlayer";
import currSymbol from "currency-symbol-map";
import LoadingIndicator from "@/components/LoadingIndicator";
import SelfServeDocuSign from "@/components/SelfService/SelfServeDocuSign.vue";

export default {
  name: "SelfServiceTaskView",
  components: {
    SelfServeDocuSign,
    LoadingIndicator, VideoPlayer, Rating, TextField, UploadManager, Note, ABtn, DataSelect, materialInput},
  data(){
    return {
      localQuotes: {},
      loadingLocal: false
    }
  },
  props: {
    project: {
      type: Object,
      required: true,
      default: () => ({})
    },
    task: {
      type: Object,
      required: true
    },
    taskIndex: {
      type: Number
    },
    projectTaskCount: {
      type: Number,
      default: null
    },
    canComplete: {
      type: Boolean,
      default: true
    },
    projectCompleted: {
      type: Boolean,
      default: false
    },
    loadingProp: {
      type: Boolean,
      default: false
    },
    taskTemplate: {
      type: Object,
      required: true,
      default() {
        return {};
      }
    }
  },
  methods:{
    setSupplierRating(supplier, key, value){
      if(!supplier.ratings) Vue.set(supplier, 'ratings', {})
      Vue.set(supplier.ratings, key, value)
    },
    async saveProject(){
      await this.$store.dispatch(
        'saveProject',
        this.project
      );
    },
    async saveTask(){
      await this.$store.dispatch('updateAction', {
        action: this.task,
        project_id: this.project.id,
        refresh_after: true,
      });
    },
    updateSuppliers(supplier, mode, type, old_value) {
      supplier.type = type;

      if (mode === 'add') {
        if (old_value && type === 'Selected') {
          // Replace selected supplier
          this.replaceSupplierSelected(supplier, mode, type, old_value)
        } else if (old_value && type === 'Final') {
          // Replace final supplier
          this.replaceSupplierFinal(supplier, mode, type, old_value);
        } else if (this.project_supplier_keys.includes(supplier.id)) {
          // Add selected supplier
          this.addNewSupplierSelected(supplier, mode, type, old_value);
        } else {
          // Add final supplier
          this.addNewSupplierFinal(supplier, mode, type, old_value);
        }
      } else {
        if (type === 'Selected') {
          // Remove a selected supplier
          this.removeSupplierSelected(supplier, mode, type, old_value);
        } else {
          // Remove a final supplier
          this.removeSupplierFinal(supplier, mode, type, old_value);
        }
      }

      this.$nextTick(() => this.saveProject());
    },
    replaceSupplierSelected(supplier, mode, type, old_value) {
      this.project.projectSuppliers.forEach((s, index) => {
        if (s.supplierId === old_value.supplierId) {
          Vue.set(this.project.projectSuppliers[index], 'type', 'Final');
        }

        if (s.supplierId === supplier.supplierId) {
          Vue.set(this.project.projectSuppliers[index], 'type', 'Selected');
        }
      });
    },
    replaceSupplierFinal(supplier, mode, type, old_value) {
      this.project.projectSuppliers.forEach((s, index) => {
        if (s.supplierId === old_value.supplierId) {
          Vue.set(this.project.projectSuppliers, index, supplier);
        }
      });
    },
    addNewSupplierSelected(supplier, mode, type, old_value) {
      this.project_supplier_keys.forEach((key, index) => {
        if (key === supplier.supplierId) {
          Vue.set(this.project.projectSuppliers[index], 'type', 'Selected');
        }
      });
    },
    addNewSupplierFinal(supplier, mode, type, old_value) {
      this.project.projectSuppliers.push(Object.assign({}, supplier));
    },
    removeSupplierSelected(supplier, mode, type, old_value) {
      this.project.projectSuppliers.forEach((s, index) => {
        if (s.supplierId === supplier.supplierId) {
          Vue.set(this.project.projectSuppliers[index],'type', 'Final');
        }
      });
    },
    removeSupplierFinal(supplier, mode, type, old_value) {
      this.project.projectSuppliers = this.project.projectSuppliers.filter(
        s => s.supplierId !== supplier.supplierId
      );
    },
    openLink(url) {
      url = url.match(/^http[s]?:\/\//) ? url : 'https://' + url;
      window.open(url, '_blank').focus();
    },
    downloadFromS3(key){
      API.getS3GETURL(key)
      .then(({signedURL}) => {
        API.downloadFile(signedURL, key);
      })
      .catch((e) => {
        console.error(e)
      })
      // API.getS3GETURL(key)
      //   .then(({ signedURL }) => {
      //     const isPDF = false// key.endsWith('.pdf'); // Simple check based on file extension
      //     if (isPDF) {
      //       window.open(signedURL, '_blank'); // Open PDFs in a new tab
      //     } else {
      //       window.open(signedURL, '_blank'); // window.location.href = signedUrl; // Direct the browser to start the download
      //     }
      //   })
      //   .catch((e) => {
      //     console.error(e);
      //     // Handle error in UI
      //   });
    },
    composeEmail(resource){
      const {address, subject, body} = resource;
      window.location.href = `mailto:${address}${subject ? ('?subject=' + subject + (body ? '&body=' + body : '')) : ''}`
    },
    runValidation(validation) {
      const taskState = this.taskState;

      function getPropValue(desc) {
        let value = taskState
        let arr = desc.split('.');
        while (arr.length) {
          value = value[arr.shift()];
        }
        return value;
      }

      function processString(str) {
        let processStr = str;

        const regex = new RegExp('{[^}]+}');
        let match;
        while (match !== null) {
          match = processStr.match(regex)
          if (!match) break
          else match = match[0]
          processStr = processStr.replace(new RegExp(match, 'g'), `getPropValue('${match.replace('{', '').replace('}', '')}')`)
        }
        return processStr;
      }

      function runFunction(valStr) {
        const processedStr = processString(valStr);
        // eslint-disable-next-line no-new-func
        return Function(`"strict mode"; return (function(getPropValue){${processedStr}})`)()(getPropValue);
      }

      return runFunction(validation)
    },
  },
  computed: {
    all_suppliers() {
      return Object.keys(this.$store.getters.suppliers).map(key => {
        return Number(this.$store.getters.suppliers[key].id);
      });
    },
    project_suppliers() {
      return this.project.projectSuppliers;
    },
    project_supplier_keys() {
      return this.project.projectSuppliers.map(supplier => supplier.supplierId);
    },
    supplier_final_keys() {
      if (!this.project || !this.project.projectSuppliers) return [];
      return this.project.projectSuppliers.map(supplier => supplier.supplierId);
    },
    supplier_awarded_keys() {
      return this.all_suppliers.filter(s => {
        const the_supplier = this.project_suppliers.find(
          supplier => supplier.supplierId === s
        );
        const is_awarded = the_supplier && the_supplier.type === 'Selected';

        return !the_supplier || is_awarded;
      });
    },
    project_suppliers_awarded() {
      return this.project_suppliers.filter(supplier => {
        return supplier.type === 'Selected';
      });
    },
    // canCompleted(){
    //   if(!this.task.requirements) return true;
    //
    //   this.task.requirements
    // }
    taskState(){
      return {
        task: this.task,
        project: this.project
      }
    },
    taskValid(){
      if(this.taskTemplate.validations && this.taskTemplate.validations.length){
        try {
          return this.taskTemplate.validations.findIndex((validation) => !this.runValidation(validation)) < 0;
        } catch(e){
          console.error(e);
          return false;
        }
      } else {
        return true;
      }
    },
    currencySymbol() {
      return currSymbol(this.$store.getters.currencyCodeById(this.project.currencyId))
    },
    loading(){
      return this.loadingLocal || this.loadingProp;
    }
  }
}
</script>

<style lang="scss" scoped>
@import "~@/styles/SelfService/colors.scss";
@import "~@/styles/SelfService/effects.scss";
@import "~@/styles/SelfService/spacing.scss";

/* Hide scrollbar for Chrome, Safari and Opera */
::-webkit-scrollbar {
  display: none;
}

.main {
  height: 100%;
  overflow-y: auto;

  /* Hide scrollbar for IE, Edge and Firefox */
  -ms-overflow-style: none;  /* IE and Edge */
  scrollbar-width: none;  /* Firefox */
}

.task-overview{
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: $spacing--xl 40px 20px;
}

.info-panel{
  height: 100%;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0 40px 20px 0;
}

.instruction-panel{
  padding: 20px;

  position: static;
  max-width: 680px;

  background: #FFFFFF;
  border-radius: 12px;

  .instruction-content {
    white-space: pre-wrap;
  }

  &.textarea{
    padding: 10px 10px 0;
    border: 1px solid $secondary;
    background-color: $background;
  }
}

.list ::v-deep ul{
  li {
    margin-bottom: 10px;
  }

  li:last-child {
    margin-bottom: 0;
  }
}


.supplier-list{
  .list-item{
    display: flex;
    justify-content: space-between;
    max-width: 680px;

    &:not(:last-child){
      margin-bottom: $spacing--l;
    }
  }
}

.resources {
  margin-bottom: $spacing--xl;
  > div:not(:last-child) {
    margin-bottom: $spacing--xl;
  }
}

::-webkit-scrollbar {
  display: none;
}
</style>
